import { state } from '@/shared/components/player/store';
import { RouteName } from '@/shared/enums';

export default {
  data() {
    return {
      liveManager: this.$services.resolve('liveManager'),
      time: this.$services.resolve('time'),
    };
  },
  computed: {
    nextProgram() {
      return state.nextProgram || {};
    },
  },
  methods: {
    playNextProgram() {
      // todo: consult state.isEmbedded here to use EmbeddedRouteName like in next-episode.js
      const { slug: articleSlug, type: articleType, id: articleId, channelId, since, till, title } = this.nextProgram;
      const channel = this.liveManager.channels.get(channelId);
      const { slug, type, id } = channel;

      this.$stats.playNext(state.product);

      // If next program is currently live, play channel instead
      if (this.time.now.isBetween(since, till)) {
        this.$storage.playFromStart = true;

        return this.$router.replace({
          name: RouteName.DETAIL,
          params: {
            id,
            slug,
            type: type.toLowerCase(),
            label: title || this.$route.params.label || '',
          },
        });
      }

      this.$router.replace({
        name: RouteName.DETAIL_WITH_ARTICLE,
        params: {
          label: 'programme',
          slug,
          type: type.toLowerCase(),
          id,
          articleSlug,
          articleType,
          articleId,
        },
      });
    },
  },
};
